import { Carousel, Grid } from "@scuf/common";
import Bar from "../../components/charts/Bar/Bar";
import Column from "../../components/charts/Column/Column";

const GraficosUtilizacion = () => {
  // Variable que controla el valor del Grid de la pantalla
  const graftWidth = 12;

  return (
    <>
      {/** Inicio del Carousel principal */}
      <Carousel
        className="carousel-custom carousel-custom-600"
        autoPlay={true}
        transitionTime={10000}
      >
        {/** Slide de CHUQUICAMATA */}
        <Carousel.Slide
          theme="dark"
          content={
            <>
              <div style={{ padding: "0px", width: "100%"}}>
                <Grid.Row>
                  <Grid.Column
                    xsWidth={graftWidth}
                    sWidth={graftWidth}
                    mWidth={graftWidth}
                    lWidth={graftWidth}
                    xlWidth={graftWidth}
                  >
                    <Bar
                      url="sp_GetData"
                      body={{ params: "020201" }}
                      isCard="0"
                      titleCard="CHUQUICAMATA"
                      name="Utilizacion Profit"
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column
                    xsWidth={graftWidth}
                    sWidth={graftWidth}
                    mWidth={graftWidth}
                    lWidth={graftWidth}
                    xlWidth={graftWidth}
                  >
                    <div style={{ padding: "0px", width: "100%" }}>
                      <Column
                        url="sp_GetData"
                        body={{ params: "020202" }}
                        isCard="0"
                        titleCard="Ultimos 7 días"
                        name="Utilizacion Profit Ultimos 7 Días"
                      />
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </div>
            </>
          }
        ></Carousel.Slide>

        {/** Slide de RADOMIRO TOMIC */}
        <Carousel.Slide
          theme="dark"
          content={
            <>
              <div style={{ padding: "0px", width: "100%" }}>
                <Grid.Row>
                  <Grid.Column
                    xsWidth={graftWidth}
                    sWidth={graftWidth}
                    mWidth={graftWidth}
                    lWidth={graftWidth}
                    xlWidth={graftWidth}
                  >
                    <Bar
                      url="sp_GetData"
                      body={{ params: "020701" }}
                      isCard="0"
                      titleCard="RADOMIRO TOMIC"
                      name="Utilizacion Profit"
                    />
                  </Grid.Column>
                  <Grid.Column
                    xsWidth={graftWidth}
                    sWidth={graftWidth}
                    mWidth={graftWidth}
                    lWidth={graftWidth}
                    xlWidth={graftWidth}
                  >
                    <div style={{ padding: "0px", width: "100%" }}>
                      <Column
                        url="sp_GetData"
                        body={{ params: "020702" }}
                        isCard="0"
                        titleCard="Ultimos 7 días"
                        name="Utilizacion Profit Ultimos 7 Días"
                      />
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </div>
            </>
          }
        ></Carousel.Slide>

        {/** Slide de MINISTRO HALES */}
        <Carousel.Slide
          theme="dark"
          content={
            <>
              <div style={{ padding: "0px", width: "100%" }}>
                <Grid.Row>
                  <Grid.Column
                    xsWidth={graftWidth}
                    sWidth={graftWidth}
                    mWidth={graftWidth}
                    lWidth={graftWidth}
                    xlWidth={graftWidth}
                  >
                    <div
                      style={{
                        padding: "0px",
                        width: "100%"
                      }}
                    >
                      <Bar
                        url="sp_GetData"
                        body={{ params: "020301" }}
                        isCard="0"
                        titleCard="MINISTRO HALES"
                        name="Utilizacion Profit"
                      />
                    </div>
                  </Grid.Column>
                  <Grid.Column
                    xsWidth={graftWidth}
                    sWidth={graftWidth}
                    mWidth={graftWidth}
                    lWidth={graftWidth}
                    xlWidth={graftWidth}
                  >
                    <div
                      style={{
                        padding: "0px",
                        width: "100%"
                      }}
                    >
                      <Column
                        url="sp_GetData"
                        body={{ params: "020302" }}
                        isCard="0"
                        titleCard="&nbsp;"
                        name="Utilizacion Profit Ultimos 7 Días"
                      />
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </div>
            </>
          }
        ></Carousel.Slide>

        {/** Slide de GABRIELA MISTRAL */}
        <Carousel.Slide
          theme="dark"
          content={
            <>
              <div style={{ padding: "0px", width: "100%" }}>
                <Grid.Row>
                  <Grid.Column
                    xsWidth={graftWidth}
                    sWidth={graftWidth}
                    mWidth={graftWidth}
                    lWidth={graftWidth}
                    xlWidth={graftWidth}
                  >
                    <div style={{ padding: "0px", width: "100%" }}>
                      <Bar
                        url="sp_GetData"
                        body={{ params: "020801" }}
                        isCard="0"
                        titleCard="GABRIELA MISTRAL"
                        name="Utilizacion Profit"
                      />
                    </div>
                  </Grid.Column>
                  <Grid.Column
                    xsWidth={graftWidth}
                    sWidth={graftWidth}
                    mWidth={graftWidth}
                    lWidth={graftWidth}
                    xlWidth={graftWidth}
                  >
                    <div style={{ padding: "0px", width: "100%" }}>
                      <Column
                        url="sp_GetData"
                        body={{ params: "020802" }}
                        isCard="0"
                        titleCard="Ultimos 7 días"
                        name="Utilizacion Profit Ultimos 7 Días"
                      />
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </div>
            </>
          }
        ></Carousel.Slide>

        {/** Slide de  SALVADOR*/}
        <Carousel.Slide
          theme="dark"
          content={
            <>
              <div style={{ padding: "0px", width: "100%" }}>
                <Grid.Row>
                  <Grid.Column
                    xsWidth={graftWidth}
                    sWidth={graftWidth}
                    mWidth={graftWidth}
                    lWidth={graftWidth}
                    xlWidth={graftWidth}
                  >
                    <div
                      style={{
                        padding: "0px",
                        width: "100%",
                      }}
                    >
                      <Bar
                        url="sp_GetData"
                        body={{ params: "020401" }}
                        isCard="0"
                        titleCard="SALVADOR"
                        name="Utilizacion Profit"
                        
                      />
                    </div>
                  </Grid.Column>
                  <Grid.Column
                    xsWidth={graftWidth}
                    sWidth={graftWidth}
                    mWidth={graftWidth}
                    lWidth={graftWidth}
                    xlWidth={graftWidth}
                  >
                    <div
                      style={{
                        padding: "0px",
                        width: "100%",
                      }}
                    >
                      <Column
                        url="sp_GetData"
                        body={{ params: "020402" }}
                        isCard="0"
                        titleCard="&nbsp;"
                        name="Utilizacion Profit Ultimos 7 Días"
                      />
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </div>
            </>
          }
        ></Carousel.Slide>

        {/** Slide de  ANDINA*/}
        <Carousel.Slide
          theme="dark"
          content={
            <>
              <div style={{ padding: "0px", width: "100%" }}>
                <Grid.Row>
                  <Grid.Column
                    xsWidth={graftWidth}
                    sWidth={graftWidth}
                    mWidth={graftWidth}
                    lWidth={graftWidth}
                    xlWidth={graftWidth}
                  >
                    <div
                      style={{
                        padding: "0px",
                        width: "100%",
                      }}
                    >
                      <Bar
                        url="sp_GetData"
                        body={{ params: "020501" }}
                        isCard="0"
                        titleCard="ANDINA"
                        name="Utilizacion Profit"
                      />
                    </div>
                  </Grid.Column>
                  <Grid.Column
                    xsWidth={graftWidth}
                    sWidth={graftWidth}
                    mWidth={graftWidth}
                    lWidth={graftWidth}
                    xlWidth={graftWidth}
                  >
                    <div
                      style={{
                        padding: "0px",
                        width: "100%",
                      }}
                    >
                      <Column
                        url="sp_GetData"
                        body={{ params: "020502" }}
                        isCard="0"
                        titleCard="&nbsp;"
                        name="Utilizacion Profit Ultimos 7 Días"
                      />
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </div>
            </>
          }
        ></Carousel.Slide>

        {/** Slide de TENIENTE*/}
        <Carousel.Slide
          theme="dark"
          content={
            <>
              <div style={{ padding: "0px", width: "100%"}}>
                <Grid.Row>
                  <Grid.Column
                    xsWidth={graftWidth}
                    sWidth={graftWidth}
                    mWidth={graftWidth}
                    lWidth={graftWidth}
                    xlWidth={graftWidth}
                  >
                    <div
                      style={{
                        padding: "0px",
                        width: "100%",
                      }}
                    >
                      <Bar
                        url="sp_GetData"
                        body={{ params: "020601" }}
                        isCard="0"
                        titleCard="EL TENIENTE"
                        name="Utilizacion Profit"
                      />
                    </div>
                  </Grid.Column>
                  <Grid.Column
                    xsWidth={graftWidth}
                    sWidth={graftWidth}
                    mWidth={graftWidth}
                    lWidth={graftWidth}
                    xlWidth={graftWidth}
                  >
                    <div
                      style={{
                        padding: "0px",
                        width: "100%",
                      }}
                    >
                      <Column
                        url="sp_GetData"
                        body={{ params: "020602" }}
                        isCard="0"
                        titleCard="&nbsp;"
                        name="Utilizacion Profit Ultimos 7 Días"
                      />
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </div>
            </>
          }
        ></Carousel.Slide>

        {/** Fin del Carousel principal */}
      </Carousel>
    </>
  );
};

export default GraficosUtilizacion;
